export default __webpack_public_path__ + "static/media/indoor.6f2129a3.xlsm";